import {DeleteFavoriteDoctorRequest} from 'domain/usecases';
import {makeDeleteFavoriteDoctor} from 'main/factories/usecases';

export async function deleteFavoriteDoctor({
	cdEspecialidade,
	cdPrestador,
	cdSubEspecialidade,
	signal,
}: DeleteFavoriteDoctorRequest) {
	await makeDeleteFavoriteDoctor().delete({cdEspecialidade, cdSubEspecialidade, cdPrestador, signal});
}
